/**
 * Import Dependency
 */
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'

/**
 * Import Component
 */
import OptionGroupsButtons from '../../components/OptionGroupsButtons'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {
    stash: state.stash,
    stashByOptionGroups: state.stashByOptionGroups,
    isActiveBottomSheetSubmitButton: state.isActiveBottomSheetSubmitButton,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {

  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(OptionGroupsButtons)))



// WEBPACK FOOTER //
// ./src/containers/components/OptionGroupsButtons.js